import { privateApi, publicApi } from '../config';

const endpoint = '/service-docs/v1/certificados';

export function buscar(filtros) {
  return privateApi.get(endpoint, { params: filtros });
}

/* export function assinar(id) {
  return privateApi.put(`${endpoint}/${id}/documento`);
} */

export function assinar(id) {
  return privateApi.put(`${endpoint}/documentos`, { ids: id });
}

export function validar(codigo) {
  return privateApi.get(`${endpoint}/validacao/${codigo}`);
}

export function validarExterno(code) {
  return publicApi.get(`${endpoint}/publico/validacao/${code}`);
}
